import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=c860884a&"
import script from "./ProjectInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c860884a')) {
      api.createRecord('c860884a', component.options)
    } else {
      api.reload('c860884a', component.options)
    }
    module.hot.accept("./ProjectInformation.vue?vue&type=template&id=c860884a&", function () {
      api.rerender('c860884a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/ProjectInformation.vue"
export default component.exports